module.exports = {
	"id": "AU",
	"name": "Australia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016563,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.016563,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.027605,
			"27": null,
			"28": null,
			"29": 0.011042,
			"30": 0.011042,
			"31": 0.077294,
			"32": 0.011042,
			"33": 0.027605,
			"34": 0.038647,
			"35": 0.022084,
			"36": 0.016563,
			"37": 0.022084,
			"38": 0.044168,
			"39": 0.060731,
			"40": 0.033126,
			"41": 0.05521,
			"42": 0.082815,
			"43": 0.099378,
			"44": 0.088336,
			"45": 0.248445,
			"46": 0.099378,
			"47": 0.126983,
			"48": 0.143546,
			"49": 1.175973,
			"50": 0.248445,
			"51": 0.518974,
			"52": 0.933049,
			"53": 21.498774,
			"54": 4.880564,
			"55": 0.060731,
			"56": 0.016563,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.011042,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005521,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.005521,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005521,
			"30": 0.005521,
			"31": 0.011042,
			"32": 0.005521,
			"33": 0.011042,
			"34": 0.033126,
			"35": 0.011042,
			"36": 0.011042,
			"37": 0.022084,
			"38": 0.093857,
			"39": 0.027605,
			"40": 0.022084,
			"41": 0.027605,
			"42": 0.033126,
			"43": 0.066252,
			"44": 0.027605,
			"45": 0.171151,
			"46": 0.05521,
			"47": 0.303655,
			"48": 0.436159,
			"49": 4.891606,
			"50": 0.071773,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.005521
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005521,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005521,
			"35": null,
			"36": 0.011042,
			"37": 0.022084,
			"38": 0.016563,
			"39": 0.005521,
			"40": 0.138025,
			"41": 0.022084,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.016563
		},
		"safari": {
			"0": null,
			"4": 0.005521,
			"5": 0.038647,
			"6": 0.016563,
			"7": 0.066252,
			"8": 0.397512,
			"9": 0.695646,
			"10": 2.351946,
			"3.1": null,
			"3.2": null,
			"5.1": 0.138025,
			"6.1": 0.104899,
			"7.1": 0.022084,
			"9.1": 2.053812
		},
		"ios_saf": {
			"8": 0,
			"10": 16.4052903597,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.442103592215,
			"8.1-8.4": 0.816767653414,
			"9.0-9.2": 0.389650623647,
			"9.3": 5.94466977102
		},
		"android": {
			"3": 0,
			"4": 0.0230084031008,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0028760503876,
			"4.1": 0.0829945968992,
			"4.2-4.3": 0.207486492248,
			"4.4": 0.475780906977,
			"4.4.3-4.4.4": 0.479889550388
		},
		"ie": {
			"6": 0.00561911147011,
			"7": 0.0112382229402,
			"8": 0.236002681745,
			"9": 0.280955573506,
			"10": 0.258479127625,
			"11": 6.15854617124,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0657922255445,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00182756182068
		},
		"edge": {
			"12": 0.099378,
			"13": 0.706688,
			"14": 2.180795
		},
		"ie_mob": {
			"10": 0.0697714647887,
			"11": 0.284069535211
		},
		"bb": {
			"7": 0.0067185,
			"10": null
		},
		"samsung": {
			"0": 4.07589
		},
		"and_uc": {
			"0": 1.101834
		},
		"op_mini": {
			"0": 0.886407212635
		},
		"and_chr": {
			"0": 13.951963
		},
		"and_ff": {
			"0": 0.04479
		}
	},
	"total": 98.9156713885
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AU.json
 ** module id = 467
 ** module chunks = 0
 **/